import React from 'react';
import { useListContext } from 'react-admin';
import makeStyles from '@mui/styles/makeStyles';

import { Note } from './Note';
import { NewNote } from './NewNote';

const useStyles = makeStyles({
    root: {
        marginTop: '0.5em',
    },
});

const NotesIterator = ({
    showStatus,
    reference,
    foreignKeyMapping,
    record,
    ...rest
}) => {
    const classes = useStyles();
    const { data, isPending } = useListContext();
    if (isPending) return null;
    return (
        <>
            <NewNote showStatus={showStatus} record={record} reference={reference} foreignKeyMapping={foreignKeyMapping}/>
            <div className={classes.root}>
                {data?.map((note, index) => (
                    <Note
                        note={data[index]}
                        isLast={index === data.length - 1}
                        showStatus={showStatus}
                        reference={reference}
                        record={record}
                        key={index}
                    />
                )) || null}
            </div>
        </>
    );
};

export { NotesIterator };
